<button
  type="button"
  class="notification-trigger"
  (click)="op.toggle($event)"
  [attr.aria-label]="'notifications.title' | translate">
  <i *ngIf="unreadCount > 0; else plainBell" class="pi pi-bell" pBadge [value]="badgeValue" severity="danger"></i>
  <ng-template #plainBell><i class="pi pi-bell"></i></ng-template>
</button>

  <p-popover #op appendTo="body" styleClass="notification-popover" (onShow)="loadFirstPage()">
    <div class="notification-panel">
      <div class="notification-panel-header">
        <span class="notification-panel-title">{{ 'notifications.title' | translate }}</span>
        <div class="notification-panel-actions">
          <button type="button" class="link-btn" (click)="markAllRead()" [disabled]="unreadCount === 0">
            {{ 'notifications.markAllRead' | translate }}
          </button>
          <button type="button" class="link-btn danger" (click)="clearAll()" [disabled]="notifications.length === 0">
            {{ 'notifications.clearAll' | translate }}
          </button>
        </div>
      </div>

      <div class="notification-list">
        <div *ngIf="loading" class="notification-state">{{ 'common.loading' | translate }}</div>

        <ng-container *ngIf="!loading">
          <div *ngIf="notifications.length === 0" class="notification-state">
            {{ 'notifications.empty' | translate }}
          </div>

          <div
            *ngFor="let n of notifications; trackBy: trackById"
            class="notification-item"
            [class.unread]="!n.isRead"
            (click)="onItemClick(n)">
            <i class="notification-item-icon" [ngClass]="iconFor(n)"></i>
            <div class="notification-item-body">
              <div class="notification-item-label">{{ labelFor(n) }}</div>
              <div class="notification-item-text" *ngIf="bodyFor(n) as body">{{ body }}</div>
              <div class="notification-item-date">{{ n.createdDate | date:'medium' }}</div>
            </div>
            <span *ngIf="!n.isRead" class="notification-dot"></span>
          </div>
        </ng-container>
      </div>

      <div class="notification-panel-footer" *ngIf="hasMore">
        <button type="button" class="link-btn" (click)="loadMore()" [disabled]="loadingMore">
          {{ (loadingMore ? 'common.loading' : 'notifications.loadMore') | translate }}
        </button>
      </div>
    </div>
  </p-popover>

  <p-confirmDialog>
    <ng-template pTemplate="message" let-confirmation>
      <div class="confirm-message">
        <i *ngIf="confirmation.icon" [ngClass]="confirmation.icon" class="confirm-message-icon"></i>
        <span [innerHTML]="confirmation.message"></span>
      </div>
    </ng-template>
  </p-confirmDialog>
  <p-toast />
